import type {
  PaymentMethodDtoWithIsPreferredPaymentMethodTypeEnumKey,
  RulePayer,
} from 'korint-sdk';

/**
 * Per-payer payment-method requirement for finalizeNewBusiness rules: an OFFLINE payer is never
 * charged, so no method can be demanded of them; every other payer needs one (of the required
 * type when given). Mirrors the backend signature guard, getPaymentMethodSignatureDocuments.
 *
 * Any product enabling OFFLINE must build its payment-method rule through this helper — a
 * config test enforces it, because a hand-written rule demanding a method blocks an offline
 * customer's checklist forever.
 */
export const offlineAwarePaymentMethodRule =
  ({
    requiredType,
  }: {
    requiredType?: PaymentMethodDtoWithIsPreferredPaymentMethodTypeEnumKey;
  } = {}) =>
  ({ payers }: { payers: RulePayer[] }): boolean =>
    payers.every(
      ({ customer, paymentMethods }) =>
        customer.paymentMode === 'OFFLINE' ||
        (requiredType
          ? paymentMethods.some(({ paymentMethodType }) => paymentMethodType === requiredType)
          : paymentMethods.length > 0),
    );
